import { FormikDrawer } from 'shared/form/FormikDrawer';
import { useEstimateSeatsUpgrade, useSubscription } from '../SubscriptionAPI';
import { PlanUpdateDrawerContent } from './PlanUpdateDrawerContent';
import { useState } from 'react';
import { CardDetailsDrawerContent } from './CardDetailsDrawerContent';

export function useNextPlanEstimate() {
  const { billableSeats } = useSubscription();

  const seatsCount = billableSeats?.reserved_seats
    ? Number(billableSeats?.reserved_seats) + 1
    : 1;

  return useEstimateSeatsUpgrade(seatsCount, {
    enabled: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
  });
}

interface PlanUpdateDrawerProps {
  open: boolean;
  onClose: () => void;
  onSubmitSuccess: () => void;
}

export function PlanUpdateDrawer({
  open,
  onClose,
  onSubmitSuccess,
}: PlanUpdateDrawerProps) {
  const [step, setStep] = useState<'plan_update' | 'card_details'>(
    'plan_update',
  );
  return (
    <FormikDrawer
      open={open}
      onClose={() => {
        onClose();
        setStep('plan_update');
      }}
    >
      {step === 'plan_update' ? (
        <PlanUpdateDrawerContent
          onClose={onClose}
          setStep={setStep}
          onSubmitSuccess={onSubmitSuccess}
        />
      ) : (
        <CardDetailsDrawerContent
          onClose={onClose}
          onBack={() => {
            setStep('plan_update');
          }}
        />
      )}
    </FormikDrawer>
  );
}
